import React from "react";
import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M13.6481 10.0002H18.3265C18.6929 9.98095 18.9025 10.0097 19.1009 10.2561C19.3569 10.5745 19.2561 10.8178 19.0129 11.1154L9.60813 22.501C9.32013 22.797 9.14413 22.9137 8.76013 22.7617C8.34413 22.5985 8.32333 22.3794 8.39853 21.933L10.3345 13.965H5.53933C5.19373 13.9746 4.89613 13.8786 4.78093 13.5154C4.69293 13.2306 4.79853 13.0306 4.97773 12.8434L14.3937 1.44815C14.6465 1.21455 14.8145 1.11535 15.1457 1.20335C15.5905 1.32015 15.6417 1.57455 15.5905 2.01455L13.6481 9.99855V10.0002Z" />
  </React.Fragment>,
  "CombinedData"
);
